import AdminViewIcon from '@/assets/icons/admin-view.svg?react'
import MemberViewIcon from '@/assets/icons/member-view.svg?react'
import { Trans } from '@/components/Trans'
import { cn } from '@/utils/style'

export type ViewMode = 'member' | 'admin'

interface ViewSwitcherProps {
  value: ViewMode
  onChange: (mode: ViewMode) => void
}

export function ViewSwitcher({ value, onChange }: ViewSwitcherProps) {
  return (
    <div className="bg-neutral-50 p-1 rounded-xl flex gap-1">
      <button
        type="button"
        className={cn(
          'flex items-center gap-1 px-4 py-2 rounded-lg transition-colors t-x-sb',
          value === 'member'
            ? 'bg-highlight/10 text-highlight'
            : 'bg-neutral-50 text-primary hover:bg-neutral-200',
        )}
        onClick={() => onChange('member')}
      >
        <MemberViewIcon className="w-5 h-5" />
        <Trans i18nKey="common.viewSwitcher.memberView">Member View</Trans>
      </button>
      <button
        type="button"
        className={cn(
          'flex items-center gap-1 px-4 py-2 rounded-lg transition-colors t-x-sb',
          value === 'admin'
            ? 'bg-highlight/10 text-highlight'
            : 'bg-neutral-50 text-primary hover:bg-neutral-200',
        )}
        onClick={() => onChange('admin')}
      >
        <AdminViewIcon className="w-5 h-5" />
        <Trans i18nKey="common.viewSwitcher.adminView">Admin View</Trans>
      </button>
    </div>
  )
}
